import { Modal } from '@gerdau/hefesto/Modal';
import { TextField } from '@gerdau/hefesto/TextField';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../../../../../store';
import { removeMockup } from '../../../../../../../store/ducks/fabrication-mockups/actions';
import { sendTagging } from '../../../../../../../store/ducks/tagging/actions';
import { RemoveMockupModalContainer } from './styles';

interface RemoveMockupProps {
  mockupId: number;
  mockupName: string;
  contractNumber: string;
  onCancel: () => void;
}

const RemoveMockup: React.FC<RemoveMockupProps> = ({
  mockupId,
  mockupName,
  contractNumber,
  onCancel
}) => {
  const dispatch = useDispatch();

  const removeMockupState = useSelector(
    (appState: ApplicationState) =>
      appState.fabricationMockups.removeMockupState
  );

  const [reasonOfExclusion, setReasonOfExclusion] = useState('');

  const handleRemoveMockup = () => {
    dispatch(removeMockup(mockupId, contractNumber));
  };

  return (
    <Modal
      onClose={onCancel}
      modalSize="lg"
      title={`Deseja excluir a maquete ${mockupName}`}
      buttons={{
        left: {
          children: 'Cancelar',
          name: 'Cancelar',
          onClick: () => {
            dispatch(
              sendTagging({
                event: 'click',
                itemName: 'button:cancelar',
                itemDescription: `maquetesEProjetos_maquetes_modalExcluirMaquetes_cancelar`,
                screenName: 'LG:MaquetesEProjetos:Maquetes:ModalExcluirMaquetes'
              })
            );
            onCancel();
          },
          type: 'button',
          disabled: removeMockupState?.loading
        },
        right: {
          children: 'Excluir maquete',
          name: 'Excluir maquete',
          onClick: () => {
            dispatch(
              sendTagging({
                event: 'click',
                itemName: 'button:excluir_maquete',
                itemDescription: `maquetesEProjetos_maquetes_modalExcluirMaquetes__excluirMaquete`,
                screenName: 'MaquetesEProjetos:Maquetes:ModalExcluirMaquetes'
              })
            );
            handleRemoveMockup();
          },
          variant: 'danger',
          type: 'button',
          disabled: !reasonOfExclusion || removeMockupState?.loading,
          loading: removeMockupState?.loading
        }
      }}
    >
      <RemoveMockupModalContainer>
        Para excluir, informe no campo abaixo o motivo:
        <TextField
          label="Motivo da exclusão"
          name="Motivo da exclusão"
          value={reasonOfExclusion}
          onChange={(e) => setReasonOfExclusion(e.target.value)}
          placeholder="Escreva o motivo da exclusão"
          disabled={removeMockupState?.loading}
        />
      </RemoveMockupModalContainer>
    </Modal>
  );
};

export default RemoveMockup;
